<template>
  <div v-resize="onResize">

    <!------------otras funciones---------------->
    <v-snackbar v-model="aalert.estado" :color="aalert.color" :timeout="120000" :vertical="true"
                style="margin-top: 20%;" top="top">
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- ------------------------------------------------------ Modal-Correo-->
    <v-dialog v-model="dialogEmail" label="Modal agregar Correo" max-height="80%" max-width="80%"
              persistent transition="dialog-bottom-transition">

      <v-card color="grey lighten-3">
        <v-toolbar color="#BDBDBD" dense flat style="border: 1px solid #000000;">

          <v-avatar size="45" tile>
            <i class="fa fa-envelope-o" style="font-size: 40px; color:#CDDC39;"> </i>
          </v-avatar>
          <span class="font-weight-light" style="font-size: 20px;"> <b>Enviar Reporte</b> </span>

          <!-- <v-toolbar-title    class="font-weight-light"> Reporte Producción de boletos por unidades</v-toolbar-title > -->
          <!-- style="color:white;" -->
          <!-- <i class=""> </i>     grey darken-4  -->

          <v-spacer></v-spacer>
          <v-btn color="red" fab small @click.prevent="CerrarCorreo">
            <i class="fa fa-close" style="font-size: 20px; color:white;"></i>
          </v-btn>
        </v-toolbar>

        <hr>

        <v-container style="border: 1px solid #000000;">
          <v-form ref="formReportCorreo" v-model="valid" lazy-validation @submit.prevent="" translate="no" class="notranslate">
            <v-row class="pa-0 ma-0 py-0 my-0">

              <v-col class="pa-0 ma-0 py-0 my-0" cols="12" md="12" sm="12">

                <v-text-field v-model="EnviarReporte.para" :rules="[$rules.required]" autocomplete="off" dense
                              label="* Correo:"
                              outlined>
                  <template v-slot:prepend>
                    <i class="fa fa-user-circle" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>

                <v-text-field v-model="EnviarReporte.asunto" :rules="[$rules.required]" dense label="* Asunto:"
                              outlined>
                  <template v-slot:prepend>
                    <i class="fa fa-font" style="font-size: 20px;"></i>
                  </template>
                </v-text-field>


                <v-textarea v-model="EnviarReporte.mensaje" autocomplete="off" dense label="comentario:" outlined
                            rows="5">
                  <template v-slot:prepend>
                    <i class="fa fa-commenting" style="font-size: 20px;"></i>
                  </template>
                </v-textarea>

              </v-col>

            </v-row>
          </v-form>
        </v-container>

        <hr>

        <v-toolbar class="d-flex justify-center" color="#BDBDBD" dense flat style="border: 1px solid #000000;">

          <v-btn-toggle dense rounded>
            <v-btn color="light-blue darken-2" @click.prevent="ReporteCorreo">
              <i class="fa fa-envelope-o" style="font-size: 28px; color:#CDDC39;"> </i>
              <span style="color:#FFFFFF;">Email </span>

            </v-btn>

          </v-btn-toggle>
        </v-toolbar>

      </v-card>


    </v-dialog>
    <!-- ------------------------------------------------------ fn Modal Correo -->


    <!-- ------------------------------------------------------  Modal Loader -->

    <v-dialog v-model="Reparaloading" persistent width="300">
      <v-card color="grey darken-2" dark>
        <v-card-text>
          <br></br>
          <v-progress-linear class="mb-0" color="white" indeterminate></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- ------------------------------------------------------ fn Modal loader -->

    <!----------------------------------------------------------------- Cuerpo Reporte -->

    <v-toolbar class="d-flex justify-center" color="#BDBDBD" dense flat style="border: 1px solid #000000;">

      <v-btn-toggle dense rounded>
        <v-btn v-show="propsBtnCorreo==true" color="light-blue darken-2" @click.prevent="dialogEmail = true">
          <i class="fa fa-envelope-o" style="font-size: 28px; color:#CDDC39;"> </i>
          <span style="color:#FFFFFF;">Email </span>

        </v-btn>
        <v-btn v-show="propsBtnImprimir==true"  color="light-blue accent-2" target="_blank" @click.prevent="ReporteImprimir">
          <i class="fa fa-print" style="font-size: 28px;"> </i>
          <span style="color:#FFFFFF;">Printer </span>
        </v-btn>
        <v-btn v-show="propsBtnExel==true" color="green darken-3" @click.prevent="ReporteExel">
          <i class="fa fa-file-excel-o" style="font-size: 28px;"> </i>
          <span style="color:#FFFFFF;">Excel </span>
        </v-btn>
      </v-btn-toggle>
    </v-toolbar>
    <!-------------------------------------------------------------------------------- Fn Cuerpo Reporte -->

  </div>

</template>

<script>
import {EventBus} from "@/event-bus.js";

export default {
  mounted() {
    EventBus.$on("onResize", this.onResize);
  },

  created() {
  },

  data: () => ({
    Reparaloading: false,
    EnviarReporte: {
      autor: "Jean22v@gmail.com",
      para: "",
      mensaje: "",
      asunto: "",
    },
    dialogEmail: false,
    detener: false,
    windowSize: {width: "auto", height: "auto"},
    valid: true,
    aalert: {
      estado: false,
      color: null,
    },
  }),

  props: {
    Datos: {
      required: true,
      type: Object,
    },

    ExelGenerado: {
      required: false,
      type: Boolean,
      default: false,
    },

    propsBtnImprimir: {
      required: false,
      type: Boolean,
      default: true,
    },

    propsBtnExel: {
      required: false,
      type: Boolean,
      default: true,
    },

    propsBtnCorreo: {
      required: false,
      type: Boolean,
      default: true,
    },

  },

  methods: {
    CrearObjecto() {
    },

    onResize(e) {
      var jsn = {width: window.innerWidth, height: window.innerHeight - 112};
      this.windowSize = jsn;

      // console.log("imprii ")
      // console.log(e)
      // this.windowSize=e
    },

    CerrarReporte() {
      this.$emit("DataReporteBasico", false);
    },

    ReporteImprimir() {
      this.CrearObjecto();
      if (this.detener) {
        return;
      }
      if (!this.Datos || !this.Datos.UrlImprimir) {
        this.alerta("Reporte no Impreso(datos del reporte incompletos)", "error");
        return;
      }
      EventBus.$emit("loading", true);

      var _this = this;
      setTimeout(function () {
        var obj = JSON.parse(JSON.stringify(_this.Datos));
        obj.tenant = _this.$store.getters.GetheadersAxios["X-TENANT-ID"];

        _this.$axios
            .post(_this.$hostname + _this.$hName + _this.Datos.UrlImprimir, obj, {
              headers: _this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              console.log("INF-PDF-->", res.data);
              var rutaReporte = res && res.data ? res.data.toString() : "";
              if (rutaReporte.length == 0) {
                EventBus.$emit("loading", false);
                _this.alerta("Reporte no Impreso(no se recibio la ruta del archivo)", "error");
                return;
              }
              if (rutaReporte.includes(".txt")) {
                var fileName = "prueba.txt";
                var url =
                    _this.$hostname + _this.$hName + "/configuraciones/texts/";
              } else {
                var fileName = "prueba.pdf";
                var url =
                    _this.$hostname + _this.$hName + "/configuraciones/imprimir/";
              }

              //Create XMLHTTP Request.
              var req = new XMLHttpRequest();
              req.open("GET", url, true);
              req.setRequestHeader(
                  "Authorization",
                  _this.$store.getters.GetheadersAxios.Authorization
              );
              req.setRequestHeader(
                  "X-TENANT-ID",
                  _this.$store.getters.GetheadersAxios["X-TENANT-ID"]
              );
              req.setRequestHeader(
                  "Content-Type",
                  _this.$store.getters.GetheadersAxios["Content-Type"]
              );
              req.setRequestHeader("ruta", rutaReporte);

              req.responseType = "blob";
              req.onload = function () {
                //Convert the Byte Data to BLOB object.
                if (rutaReporte.includes(".txt")) {
                  var blob = new Blob([req.response], {type: "text/plain"});
                  var isIE = false;
                  if (isIE) {
                    navigator.msSaveBlob(blob, fileName);
                  } else {
                    var url = URL || webkitURL;
                    var link = url.createObjectURL(blob);
                    var downloadLink = document.createElement("a");
                    downloadLink.href = link;
                    downloadLink.download = "reporte.txt";
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                  }
                } else {
                  var blob = new Blob([req.response], {
                    type: "application/pdf",
                  });
                  var isIE = false || !!document.documentMode;
                  if (isIE) {
                    navigator.msSaveBlob(blob, fileName);
                  } else {
                    console.log("blob-->", blob);
                    var url = URL || webkitURL;
                    var link = url.createObjectURL(blob);
                    console.log("--> lolo", link);
                    var PDF = `${link}`;
                    EventBus.$emit("openPDF", PDF, _this.Datos.nombre);

                    return;
                  }
                }
              };
              req.send();
              // this.Reparaloading = false
              EventBus.$emit("loading", false);
            })
            .catch((error) => {
              // this.Reparaloading = false
              EventBus.$emit("loading", false);
              if (error.response) {
                _this.alerta(
                    "Reporte no Impreso(" + error.message + ")",
                    "error"
                );
              }
            });
      }, 300);
    },

    CerrarCorreo() {
      this.EnviarReporte = {
        para: "",
        mensaje: "",
        asunto: "",
      };

      this.dialogEmail = false;
    },

    ReporteCorreo() {
      this.CrearObjecto();
      if (this.detener) {
        return;
      }

      if (this.$refs.formReportCorreo.validate()) {
        //  this.Reparaloading = true
        EventBus.$emit("loading", true);

        var obj = this.Datos;
        obj.para = this.EnviarReporte.para;
        obj.mensaje = this.EnviarReporte.mensaje;
        obj.asunto = this.EnviarReporte.asunto;
        obj.tenant = this.$store.getters.GetheadersAxios["X-TENANT-ID"];
        this.$axios
            .post(this.$hostname + this.$hName + this.Datos.UrlCorreo, obj, {
              headers: this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              // this.Reparaloading = false
              EventBus.$emit("loading", false);
              this.alerta("Correo enviado correctamente!", "bien");
              this.CerrarCorreo();
            })
            .catch((error) => {
              //  this.Reparaloading = false
              EventBus.$emit("loading", false);
              // this.alerta("Reporte no Impreso(" + error + ")", "error")
            });
      } else {
        this.alerta("los campos en rojo son requeridos", "error");
      }
    },

    ReporteExel() {
      this.CrearObjecto();
      if (this.detener) {
        return;
      }
      // this.Reparaloading = true
      EventBus.$emit("loading", true);

      var _this = this;
      setTimeout(function () {
        var obj = JSON.parse(JSON.stringify(_this.Datos));
        obj.tenant = _this.$store.getters.GetheadersAxios["X-TENANT-ID"];

        // var obj={
        // tenant:this.$store.getters.GetheadersAxios["X-TENANT-ID"],
        // secuencia:this.Datos.secuencia,
        // documento: this.Datos.documento,
        // }

        _this.$axios
            .post(_this.$hostname + _this.$hName + _this.Datos.UrlExel, obj, {
              headers: _this.$store.getters.GetheadersAxios,
            })
            .then((res) => {
              // this.Reparaloading = false
              EventBus.$emit("loading", false);
              // var _this = this;

              // console.log('Ressssspuuuu'),console.log(res.data),this.alerta("Dato guardado correctamente!", "bien")
              setTimeout(function () {
                _this.verExel(res.data);
              }, 2000);

              // this.CrearObjecto=function(){};
            })
            .catch((error) => {
              // this.Reparaloading = false
              /*  EventBus.$emit("loading", false),
                _this.alerta("Reporte no Impreso(" + error + ")", "error")*/
              console.log(error);
              let msg = "";
              if (error.response) {
                msg = error.response.data;
              } else if (error.request) {
                msg = error.request.data;
              } else {
                msg = error.message;
              }
              _this.catchErroExel(msg);
            });
      }, 300);
    },

    verExel(e) {
      console.log(e);

      // if (this.ExelGenerado == true) {

      var contentType = "application/vnd.ms-excel";
      //var contentType = 'text/csv'

      // }

      // if (this.ExelGenerado == false) {
      // var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      // }

      var blob1 = this.b64toBlob(e, contentType);
      var blobUrl1 = URL.createObjectURL(blob1);
      let anchor = document.createElement("a");
      anchor.href = blobUrl1;
      anchor.download = this.Datos.nombre;
      anchor.click();
      URL.revokeObjectURL(blobUrl1);
    },

    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
          var offset = 0;
          offset < byteCharacters.length;
          offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    },

    catchErroExel(e) {
      EventBus.$emit("loading", false);
      if (e.includes("Invalid row number")) {
        var TXT =
            "Este archivo de Excell contiene mas de 1,048,576 de registros, y no es soportado por Excel. Favor de generar otro rango de fecha.";
        this.alerta(TXT, "error");
      } else {
        this.alerta(e, "error");
      }
    },

    alerta(e, l) {
      if (l == "bien") {
        (this.aalert.estado = true),
            (this.aalert.color = "success"),
            (this.aalert.nombre = e);

        // this.newwnuevo();
      }

      if (l == "error") {
        (this.aalert.estado = true),
            (this.aalert.color = "error"),
            (this.aalert.nombre = e);

        // this.ejecucion = true;
      }
    },
  },
};
</script>

<style></style>
